<template>
    <div>
        <jet-form-card @submitted="submit">
            <template #form>
                <div class="col-span-6" v-if="formType !== 'invite'">
                    <jet-label for="name" value="Name"/>
                    <jet-input id="name" type="text" class="mt-1 block w-full" v-model="form.name" required
                               :error="!!form.errors.name"
                               autofocus/>
                    <jet-input-error :message="form.errors.name"/>
                </div>

                <div class="col-span-6">
                    <jet-label for="email" value="Email"/>
                    <jet-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required
                               :error="!!form.errors.email"
                               autofocus/>
                    <jet-input-error :message="form.errors.email"/>
                </div>

                <div class="col-span-6" v-if="formType !== 'invite'">
                    <jet-label for="password" value="Password"/>
                    <jet-input :disabled="form.id === $page.props.auth.user.id" id="password" type="password"
                               :error="!!form.errors.password"
                               autocomplete="new-password"
                               class="mt-1 block w-full" v-model="form.password"/>
                    <jet-input-error :message="form.errors.password"/>
                </div>

                <div class="col-span-6" v-if="formType !== 'invite'">
                    <jet-label for="phone" value="Phone"/>
                    <jet-input id="phone" type="tel" class="mt-1 block w-full" v-model="form.phone"
                               :error="!!form.errors.phone"
                               autofocus/>
                    <jet-input-error :message="form.errors.phone"/>
                </div>

                <div class="col-span-6" v-if="formType !== 'invite'">
                    <jet-label for="job_title" value="Job title"/>
                    <jet-input id="job_title" type="text" class="mt-1 block w-full" v-model="form.job_title"
                               :error="!!form.errors.job_title"
                               autofocus/>
                    <jet-input-error :message="form.errors.job_title"/>
                </div>

                <div class="col-span-6" v-if="form.id !== $page.props.auth.user.id">
                    <jet-label value="Roles"/>
                    <div class="mt-2">
                        <template v-for="(role, index) in roles">
                            <jet-checkbox :class="{'ml-6': index}" :value="role.id"
                                          v-model:checked="form.roles">
                                {{ role.name }}
                            </jet-checkbox>
                        </template>
                    </div>
                </div>

                <div class="col-span-6" v-if="form.roles.indexOf(superAdminRole.id) === -1">
                    <jet-label value="Client access" class="mb-2"/>
                    <div class="w-full grid grid-cols-3 gap-4 mb-4" v-for="(_, index) in form.clients">
                        <label class="block text-sm">
                                <span
                                    class="block font-medium text-sm text-gray-700 dark:text-gray-400">Select client</span>
                            <select required="" v-model="form.clients[index].id"
                                    class="block w-full mt-2 text-sm dark:text-gray-300 dark:border-gray-600 dark:bg-gray-700 form-select focus:border-red-400 focus:outline-none focus:shadow-outline-red dark:focus:shadow-outline-gray">
                                <option selected="" disabled="">-</option>
                                <option
                                    v-for="client in clients.filter(elem => !(form.clients.some(formClient => formClient.id === elem.id)) || elem.id === form.clients[index].id)"
                                    :key="client.id" :value="client.id">{{ client.name }}
                                </option>
                            </select>
                        </label>
                        <div class="flex items-end">
                            <button @click.prevent="removeClientRole(index)"
                                    class="flex items-center justify-between ml-1 px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150  border border-transparent rounded-lg focus:outline-none bg-red-600 active:bg-red-600 hover:bg-red-700 focus:shadow-outline-red"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                                     viewBox="0 0 24 24"
                                     stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                                </svg>
                            </button>
                        </div>
                        <template v-if="form.clients[index].id">
                            <div class="col-span-3">
                                <jet-checkbox :value="true"
                                              v-model:checked="form.clients[index].manager">
                                    Client manager
                                </jet-checkbox>
                            </div>
                            <template v-if="!form.clients[index].manager">
                                <div class="col-span-2">
                                    <jet-button @click.prevent="selectAllProjects(index)"
                                                :disabled="form.processing">
                                        Select all
                                    </jet-button>
                                    <jet-button class="ml-2" @click.prevent="deselectAllProjects(index)"
                                                :disabled="form.processing">
                                        Deselect all
                                    </jet-button>
                                    <span
                                        class="block font-medium text-sm text-gray-700 dark:text-gray-400 mt-2">Select projects</span>
                                    <template
                                        v-for="project in clients.find(client => client.id === form.clients[index].id).projects">
                                        <jet-checkbox class="w-full"
                                                      :value="project.id"
                                                      v-model:checked="form.clients[index].projects">
                                            {{ project.name }}
                                        </jet-checkbox>
                                    </template>
                                    <jet-input-error
                                        :message="form.errors?.[`clients.${index}.projects`]?.replace(`clients.${index}.projects`, 'projects')"/>
                                </div>
                                <div class="col-span-1">
                                    <jet-button @click.prevent="selectAllPages(index)"
                                                :disabled="form.processing">
                                        Select all
                                    </jet-button>
                                    <jet-button class="ml-2" @click.prevent="deselectAllPages(index)"
                                                :disabled="form.processing">
                                        Deselect all
                                    </jet-button>
                                    <span
                                        class="block font-medium text-sm text-gray-700 dark:text-gray-400 mt-2">Select pages</span>
                                    <template
                                        v-for="page in pageTypes">
                                        <jet-checkbox class="w-full"
                                                      :value="page.id"
                                                      v-model:checked="form.clients[index].pageTypes">
                                            {{ page.name }}
                                        </jet-checkbox>
                                    </template>
                                    <jet-input-error
                                        :message="form.errors?.[`clients.${index}.pageTypes`]?.replace(`clients.${index}.pageTypes`, 'page type')"/>
                                </div>
                            </template>
                        </template>

                    </div>
                    <button @click.prevent="addNewClientRole"
                            class="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 border border-transparent rounded-lg focus:outline-none disabled:opacity-25 transition"
                            :class="form.clients.length < clients.length ? 'bg-red-600 active:bg-red-600 hover:bg-red-700 focus:shadow-outline-red' : 'bg-gray-600 active:bg-gray-600 hover:bg-gray-700 dark:bg-gray-500 dark:hover:bg-gray-400 focus:shadow-outline-gray'">
                        <span>Add</span>
                        <span class="ml-2" aria-hidden="true">+</span>
                    </button>
                </div>

                <div class="col-span-6" v-if="formType !== 'invite'">
                    <jet-label for="active" value="Active"/>
                    <jet-select id="active" v-model:selected="form.active" :error="!!form.errors.active">
                        <option :value="true">Yes</option>
                        <option :value="false">No</option>
                    </jet-select>
                    <jet-input-error :message="form.errors.active"/>
                </div>
            </template>
            <template #actions>
                <jet-button :class="{ 'opacity-25': form.processing }"
                            :disabled="form.processing">
                    {{ buttonMessage[formType] }}
                </jet-button>
            </template>
        </jet-form-card>
    </div>
</template>

<script>
import JetInput from '@/Jetstream/Input';
import JetButton from '@/Jetstream/Button';
import JetLabel from '@/Jetstream/Label';
import JetCheckbox from '@/Jetstream/Checkbox';
import JetSelect from '@/Jetstream/Select';
import JetFormCard from '@/Jetstream/FormCard';
import JetActionMessage from '@/Jetstream/ActionMessage.vue'
import JetInputError from '@/Jetstream/InputError';
import {useForm} from "@inertiajs/inertia-vue3";

export default {
    name: 'UserForm',
    components: {
        JetInput,
        JetLabel,
        JetButton,
        JetCheckbox,
        JetSelect,
        JetFormCard,
        JetActionMessage,
        JetInputError,
    },
    props: {
        formType: {
            type: String,
            default() {
                return 'create';
            },
            validator(value) {
                return ['create', 'edit', 'invite'].includes(value)
            },
        },
        roles: {
            type: Array,
            required: true,
        },
        superAdminRole: {
            type: Object,
            required: true,
        },
        clientManagerRole: {
            type: Object,
            required: true
        },
        clients: {
            type: Object,
            required: true,
        },
        pageTypes: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: false,
        },
    },
    setup(props) {
        let form = null;
        let submit = null;

        const prepFormData = (data) => {
            if (form?.roles.indexOf(props.superAdminRole.id) !== -1) {
                data.roles = [props.superAdminRole.id];
                delete data.clients;
            }

            if (!form?.roles.length) {
                delete data.roles;
            }

            if (!form?.clients.length) {
                delete data.clients;
            }
            return data;
        }

        const emptyClientRights = {
            id: undefined,
            manager: false,
            projects: [],
            pageTypes: [],
        };

        if (props.formType === 'create' || props.formType === 'invite') {
            let formData = {
                email: null,
                roles: [],
                clients: [],
                active: true,
                phone: null,
                job_title: null,
            };

            if (props.formType === 'create') {
                form = useForm({
                    ...formData,
                    name: null,
                    password: null,
                });
                submit = () => {
                    form
                        .transform(data => prepFormData(data))
                        .post(route('admin.user.store'), {
                            onFinish: () => form.reset('password'),
                        });
                };
            } else if (props.formType === 'invite') {
                form = useForm({
                    ...formData,
                });
                submit = () => {
                    form
                        .transform(data => prepFormData(data))
                        .post(route('admin.user.invite.send'));
                };
            }


        } else {
            const roles = props.user.roles;
            const clients = [...new Set(
                roles.filter(role => role.pivot.tenant_id !== null)
                    .map(role => role.pivot.tenant_id))
            ];

            form = useForm({
                name: props.user.name,
                password: '',
                email: props.user.email,
                roles: roles.filter(role => role.pivot.tenant_id === null).map(role => role.id),
                clients: clients.map(client => ({
                    id: client,
                    manager: !! roles.filter(role =>
                        role.pivot.tenant_id === client
                        && role.id === props.clientManagerRole.id
                    ).length,
                    projects: roles.filter(role => role.pivot.tenant_id === client)
                        .filter(role => role.pivot.target_type?.includes('Project'))
                        .map(role => role.pivot.target_id),
                    pageTypes: roles.filter(role => role.pivot.tenant_id === client)
                        .filter(role => role.pivot.target_type?.includes('Page'))
                        .map(role => role.pivot.target_id),
                })),
                active: !!props.user.active,
                phone: props.user.phone,
                job_title: props.user.job_title,
            });
            submit = () => {
                form
                    .transform(data => prepFormData(data))
                    .patch(route('admin.user.update', props.user.id), {
                        onFinish: () => form.reset('password'),
                    });
            };
        }

        const buttonMessage = {
            'edit': 'Save',
            'create': 'Create user',
            'invite': 'Invite user',
        };

        const addNewClientRole = () => {
            if (form.clients.length < props.clients.length) {
                form.clients.push({...emptyClientRights});
            }
        };

        const removeClientRole = (index) => {
            form.clients.splice(index, 1);
        };

        const selectAllPages = (index) => {
            form.clients[index].pageTypes = props.pageTypes.map((pageType) => pageType.id);
        };

        const deselectAllPages = (index) => {
            form.clients[index].pageTypes = [];
        };

        const selectAllProjects = (index) => {
            form.clients[index].projects = props.clients.find(client => client.id === form.clients[index].id).projects.map((project) => project.id);
        };

        const deselectAllProjects = (index) => {
            form.clients[index].projects = [];
        };

        return {
            buttonMessage,
            form,
            addNewClientRole,
            removeClientRole,
            submit,
            selectAllPages,
            deselectAllPages,
            selectAllProjects,
            deselectAllProjects,
        };
    },
}
</script>
